// src/api/departmentApi.js
import apiClient from './axios';

const departmentApi = {
  // GET all (with pagination + search)
  getAll: async (page = 1, pageSize = 10, search = '', is_active) => {
    const response = await apiClient.get('/departments/', {
      params: { page, page_size: pageSize, search, is_active },
    });
    return response.data; // { data: [...], pagination: { ... } }
  },

  // GET by ID
  getById: async (id) => {
    const response = await apiClient.get(`/departments/${id}/`);
    return response.data;
  },

  // CREATE
  create: async (data) => {
    const response = await apiClient.post('/departments/', data);
    return response.data;
  },

  // UPDATE
  update: async (id, data) => {
    const response = await apiClient.put(`/departments/${id}/`, data);
    return response.data;
  },

  // DELETE
  delete: async (id) => {
    await apiClient.delete(`/departments/${id}/`);
    return id;
  },

  /* -------------------------- EXPORT -------------------------- */
  exportCsv: async () => {
    const response = await apiClient.get('/departments/export/', {
      responseType: 'blob',
    });
    return response.data; // Blob
  },

  /* -------------------------- IMPORT PREVIEW -------------------------- */
  importPreview: async (file) => {
    const form = new FormData();
    form.append('file', file);
    const response = await apiClient.post('/departments/import-preview/', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data; // { preview: [...], total: number }
  },

  /* -------------------------- IMPORT CONFIRM -------------------------- */
  importConfirm: async (preview) => {
    const response = await apiClient.post('/departments/import-confirm/', {
      preview,
    });
    return response.data;
  },
};

export default departmentApi;